import { POLICYRISK_INIT_LOADING, POLICYRISK_INIT_SUCCESS, POLICYRISK_INIT_FAIL, POLICYRISK_SAVE_LOADING, POLICYRISK_SAVE_SUCCESS, POLICYRISK_SAVE_FAIL,
  POLICYRISK_LIST, RISKCLSE_SAVE_LOADING, RISKCLSE_SAVE_SUCCESS, RISKCLSE_SAVE_FAIL, POLRISKSTATS_SAVE_LOADING, POLRISKSTATS_SAVE_SUCCESS, POLRISKSTATS_SAVE_FAIL,
  POLICYFIRERISK_INIT_LOADING, POLICYFIRERISK_INIT_SUCCESS, POLICYFIRERISK_INIT_FAIL, POLICYFIRERISK_SAVE_LOADING, POLICYFIRERISK_SAVE_SUCCESS, POLICYFIRERISK_SAVE_FAIL,
  POLICY_RISK_TAB, POLICYBONDRISK_INIT_LOADING, POLICYBONDRISK_INIT_SUCCESS, POLICYBONDRISK_INIT_FAIL, POLICYMISCWRKMAN_SAVE_LOADING, POLICYMISCWRKMAN_SAVE_SUCCESS,
  POLICYMISCWRKMAN_SAVE_FAIL, POLICYMISCWRKMAN_LIST, POLICYMISCEMPYT_SAVE_LOADING, POLICYMISCEMPYT_SAVE_SUCCESS, POLICYMISCEMPYT_SAVE_FAIL, POLICYMOTORRISK_INIT_LOADING,
  POLICYMOTORRISK_INIT_SUCCESS, POLICYMOTORRISK_INIT_FAIL, POLICYMOTORRISK_SAVE_LOADING, POLICYMOTORRISK_SAVE_SUCCESS, POLICYMOTORRISK_SAVE_FAIL,
  POLICYMOTORDRIVER_SAVE_LOADING, POLICYMOTORDRIVER_SAVE_SUCCESS, POLICYMOTORDRIVER_SAVE_FAIL, POLICYMOTORDRIVER_LIST, POLICYHULLRISK_INIT_LOADING,
  POLICYHULLRISK_INIT_SUCCESS, POLICYHULLRISK_INIT_FAIL, POLICYHULLRISK_SAVE_LOADING, POLICYHULLRISK_SAVE_SUCCESS, POLICYHULLRISK_SAVE_FAIL,
  POLICYCARGORISK_INIT_LOADING, POLICYCARGORISK_INIT_SUCCESS, POLICYCARGORISK_INIT_FAIL, POLICYCARGORISK_SAVE_LOADING, POLICYCARGORISK_SAVE_SUCCESS,
  POLICYCARGORISK_SAVE_FAIL, POLRISKBLK_SAVE_LOADING, POLRISKBLK_SAVE_SUCCESS, POLRISKBLK_SAVE_FAIL, RISKTRAILER_SAVE_LOADING, RISKTRAILER_SAVE_SUCCESS,
  RISKTRAILER_SAVE_FAIL, POLBORDITEM_SAVE_LOADING, POLBORDITEM_SAVE_SUCCESS, POLBORDITEM_SAVE_FAIL, POLEMPYEEDET_SAVE_LOADING, POLEMPYEEDET_SAVE_SUCCESS,
  POLEMPYEEDET_SAVE_FAIL } from '@/store/types'

export const risk = {
  [POLICYRISK_INIT_LOADING](state) {
    state.policyRiskSettings.init = 0
    state.policyRiskSettings.initErr = []
    state.policyRiskSettings.menu = {}
  },
  [POLICYRISK_INIT_SUCCESS](state, data) {
    state.policyRiskSettings.init = 1
    state.policyRiskSettings.initErr = []
    state.policyRiskSettings.menu = data.menu
  },
  [POLICYRISK_INIT_FAIL](state, error) {
    state.policyRiskSettings.init = 2
    state.policyRiskSettings.initErr = error
    state.policyRiskSettings.menu = {}
  },
  [POLICYRISK_SAVE_LOADING](state) {
    state.policy.polRisk.init = 0
    state.policy.polRisk.saving = true
    state.policy.polRisk.saveError.fieldMessages = []
    state.policy.polRisk.saveError.messages = []
  },
  [POLICYRISK_SAVE_SUCCESS](state) {
    state.policy.polRisk.init = 1
    state.policy.polRisk.saving = false
    state.policy.polRisk.saveError.fieldMessages = []
    state.policy.polRisk.saveError.messages = []
  },
  [POLICYRISK_SAVE_FAIL](state, errMsgs) {
    state.policy.polRisk.init = 2
    state.policy.polRisk.saving = false
    state.policy.polRisk.saveError.fieldMessages = errMsgs.fieldMessages
    state.policy.polRisk.saveError.messages = errMsgs.messages
  },
  [POLICYRISK_LIST](state, fullData) {
    const { data } = fullData
    state.policy.polRisk.riskList = data.data
  },
  [RISKCLSE_SAVE_LOADING](state) {
    state.policy.riskClse.init = 0
    state.policy.riskClse.saving = true
    state.policy.riskClse.saveError.fieldMessages = []
    state.policy.riskClse.saveError.messages = []
  },
  [RISKCLSE_SAVE_SUCCESS](state) {
    state.policy.riskClse.init = 1
    state.policy.riskClse.saving = false
    state.policy.riskClse.saveError.fieldMessages = []
    state.policy.riskClse.saveError.messages = []
  },
  [RISKCLSE_SAVE_FAIL](state, errMsgs) {
    state.policy.riskClse.init = 2
    state.policy.riskClse.saving = false
    state.policy.riskClse.saveError.fieldMessages = errMsgs.fieldMessages
    state.policy.riskClse.saveError.messages = errMsgs.messages
  },
  [POLRISKSTATS_SAVE_LOADING](state) {
    state.policy.polRiskStats.init = 0
    state.policy.polRiskStats.saving = true
    state.policy.polRiskStats.saveError.fieldMessages = []
    state.policy.polRiskStats.saveError.messages = []
  },
  [POLRISKSTATS_SAVE_SUCCESS](state) {
    state.policy.polRiskStats.init = 1
    state.policy.polRiskStats.saving = false
    state.policy.polRiskStats.saveError.fieldMessages = []
    state.policy.polRiskStats.saveError.messages = []
  },
  [POLRISKSTATS_SAVE_FAIL](state, errMsgs) {
    state.policy.polRiskStats.init = 2
    state.policy.polRiskStats.saving = false
    state.policy.polRiskStats.saveError.fieldMessages = errMsgs.fieldMessages
    state.policy.polRiskStats.saveError.messages = errMsgs.messages
  },
  [POLICYFIRERISK_INIT_LOADING](state) {
    state.policyFireRiskSettings.init = 0
    state.policyFireRiskSettings.initErr = []
    state.policyFireRiskSettings.menu = {}
  },
  [POLICYFIRERISK_INIT_SUCCESS](state, data) {
    state.policyFireRiskSettings.init = 1
    state.policyFireRiskSettings.initErr = []
    state.policyFireRiskSettings.menu = data.menu
  },
  [POLICYFIRERISK_INIT_FAIL](state, error) {
    state.policyFireRiskSettings.init = 2
    state.policyFireRiskSettings.initErr = error
    state.policyFireRiskSettings.menu = {}
  },
  [POLICYFIRERISK_SAVE_LOADING](state) {
    state.policy.polFireRisk.init = 0
    state.policy.polFireRisk.saving = true
    state.policy.polFireRisk.saveError.fieldMessages = []
    state.policy.polFireRisk.saveError.messages = []
  },
  [POLICYFIRERISK_SAVE_SUCCESS](state) {
    state.policy.polFireRisk.init = 1
    state.policy.polFireRisk.saving = false
    state.policy.polFireRisk.saveError.fieldMessages = []
    state.policy.polFireRisk.saveError.messages = []
  },
  [POLICYFIRERISK_SAVE_FAIL](state, errMsgs) {
    state.policy.polFireRisk.init = 2
    state.policy.polFireRisk.saving = false
    state.policy.polFireRisk.saveError.fieldMessages = errMsgs.fieldMessages
    state.policy.polFireRisk.saveError.messages = errMsgs.messages
  },
  [POLICY_RISK_TAB](state, data) {
    state.policy.policyRiskTab = data
  },
  [POLICYBONDRISK_INIT_LOADING](state) {
    state.policyBondRiskSettings.init = 0
    state.policyBondRiskSettings.initErr = []
    state.policyBondRiskSettings.menu = {}
  },
  [POLICYBONDRISK_INIT_SUCCESS](state, data) {
    state.policyBondRiskSettings.init = 1
    state.policyBondRiskSettings.initErr = []
    state.policyBondRiskSettings.menu = data.menu
  },
  [POLICYBONDRISK_INIT_FAIL](state, error) {
    state.policyBondRiskSettings.init = 2
    state.policyBondRiskSettings.initErr = error
    state.policyBondRiskSettings.menu = {}
  },
  [POLICYMISCWRKMAN_SAVE_LOADING](state) {
    state.policy.polMiscWrkman.init = 0
    state.policy.polMiscWrkman.saving = true
    state.policy.polMiscWrkman.saveError.fieldMessages = []
    state.policy.polMiscWrkman.saveError.messages = []
  },
  [POLICYMISCWRKMAN_SAVE_SUCCESS](state) {
    state.policy.polMiscWrkman.init = 1
    state.policy.polMiscWrkman.saving = false
    state.policy.polMiscWrkman.saveError.fieldMessages = []
    state.policy.polMiscWrkman.saveError.messages = []
  },
  [POLICYMISCWRKMAN_SAVE_FAIL](state, errMsgs) {
    state.policy.polMiscWrkman.init = 2
    state.policy.polMiscWrkman.saving = false
    state.policy.polMiscWrkman.saveError.fieldMessages = errMsgs.fieldMessages
    state.policy.polMiscWrkman.saveError.messages = errMsgs.messages
  },
  [POLICYMISCWRKMAN_LIST](state, fullData) {
    const { data } = fullData
    state.policy.polMiscWrkman.polMiscWrkmanList = data.polMiscWrkmanList
  },
  [POLICYMISCEMPYT_SAVE_LOADING](state) {
    state.policy.polMiscEmpyt.init = 0
    state.policy.polMiscEmpyt.saving = true
    state.policy.polMiscEmpyt.saveError.fieldMessages = []
    state.policy.polMiscEmpyt.saveError.messages = []
  },
  [POLICYMISCEMPYT_SAVE_SUCCESS](state) {
    state.policy.polMiscEmpyt.init = 1
    state.policy.polMiscEmpyt.saving = false
    state.policy.polMiscEmpyt.saveError.fieldMessages = []
    state.policy.polMiscEmpyt.saveError.messages = []
  },
  [POLICYMISCEMPYT_SAVE_FAIL](state, errMsgs) {
    state.policy.polMiscEmpyt.init = 2
    state.policy.polMiscEmpyt.saving = false
    state.policy.polMiscEmpyt.saveError.fieldMessages = errMsgs.fieldMessages
    state.policy.polMiscEmpyt.saveError.messages = errMsgs.messages
  },
  [POLICYMOTORRISK_INIT_LOADING](state) {
    state.policyMotorRiskSettings.init = 0
    state.policyMotorRiskSettings.initErr = []
    state.policyMotorRiskSettings.menu = {}
  },
  [POLICYMOTORRISK_INIT_SUCCESS](state, data) {
    state.policyMotorRiskSettings.init = 1
    state.policyMotorRiskSettings.initErr = []
    state.policyMotorRiskSettings.menu = data.menu
  },
  [POLICYMOTORRISK_INIT_FAIL](state, error) {
    state.policyMotorRiskSettings.init = 2
    state.policyMotorRiskSettings.initErr = error
    state.policyMotorRiskSettings.menu = {}
  },
  [POLICYMOTORRISK_SAVE_LOADING](state) {
    state.policy.polMtrRisk.init = 0
    state.policy.polMtrRisk.saving = true
    state.policy.polMtrRisk.saveError.fieldMessages = []
    state.policy.polMtrRisk.saveError.messages = []
  },
  [POLICYMOTORRISK_SAVE_SUCCESS](state) {
    state.policy.polMtrRisk.init = 1
    state.policy.polMtrRisk.saving = false
    state.policy.polMtrRisk.saveError.fieldMessages = []
    state.policy.polMtrRisk.saveError.messages = []
  },
  [POLICYMOTORRISK_SAVE_FAIL](state, errMsgs) {
    state.policy.polMtrRisk.init = 2
    state.policy.polMtrRisk.saving = false
    state.policy.polMtrRisk.saveError.fieldMessages = errMsgs.fieldMessages
    state.policy.polMtrRisk.saveError.messages = errMsgs.messages
  },
  [POLICYMOTORDRIVER_SAVE_LOADING](state) {
    state.policy.polMtrDrv.init = 0
    state.policy.polMtrDrv.saving = true
    state.policy.polMtrDrv.saveError.fieldMessages = []
    state.policy.polMtrDrv.saveError.messages = []
  },
  [POLICYMOTORDRIVER_SAVE_SUCCESS](state) {
    state.policy.polMtrDrv.init = 1
    state.policy.polMtrDrv.saving = false
    state.policy.polMtrDrv.saveError.fieldMessages = []
    state.policy.polMtrDrv.saveError.messages = []
  },
  [POLICYMOTORDRIVER_SAVE_FAIL](state, errMsgs) {
    state.policy.polMtrDrv.init = 2
    state.policy.polMtrDrv.saving = false
    state.policy.polMtrDrv.saveError.fieldMessages = errMsgs.fieldMessages
    state.policy.polMtrDrv.saveError.messages = errMsgs.messages
  },
  [POLICYMOTORDRIVER_LIST](state, fullData) {
    const { data } = fullData
    state.policy.polMtrDrv.polMtrDrvList = data.polMtrDrvList
  },
  [POLICYHULLRISK_INIT_LOADING](state) {
    state.policyHullRiskSettings.init = 0
    state.policyHullRiskSettings.initErr = []
    state.policyHullRiskSettings.menu = {}
  },
  [POLICYHULLRISK_INIT_SUCCESS](state, data) {
    state.policyHullRiskSettings.init = 1
    state.policyHullRiskSettings.initErr = []
    state.policyHullRiskSettings.menu = data.menu
  },
  [POLICYHULLRISK_INIT_FAIL](state, error) {
    state.policyHullRiskSettings.init = 2
    state.policyHullRiskSettings.initErr = error
    state.policyHullRiskSettings.menu = {}
  },
  [POLICYHULLRISK_SAVE_LOADING](state) {
    state.policy.polHullRisk.init = 0
    state.policy.polHullRisk.saving = true
    state.policy.polHullRisk.saveError.fieldMessages = []
    state.policy.polHullRisk.saveError.messages = []
  },
  [POLICYHULLRISK_SAVE_SUCCESS](state) {
    state.policy.polHullRisk.init = 1
    state.policy.polHullRisk.saving = false
    state.policy.polHullRisk.saveError.fieldMessages = []
    state.policy.polHullRisk.saveError.messages = []
  },
  [POLICYHULLRISK_SAVE_FAIL](state, errMsgs) {
    state.policy.polHullRisk.init = 2
    state.policy.polHullRisk.saving = false
    state.policy.polHullRisk.saveError.fieldMessages = errMsgs.fieldMessages
    state.policy.polHullRisk.saveError.messages = errMsgs.messages
  },
  [POLICYCARGORISK_INIT_LOADING](state) {
    state.policyCargoRiskSettings.init = 0
    state.policyCargoRiskSettings.initErr = []
    state.policyCargoRiskSettings.menu = {}
  },
  [POLICYCARGORISK_INIT_SUCCESS](state, data) {
    state.policyCargoRiskSettings.init = 1
    state.policyCargoRiskSettings.initErr = []
    state.policyCargoRiskSettings.menu = data.menu
  },
  [POLICYCARGORISK_INIT_FAIL](state, error) {
    state.policyCargoRiskSettings.init = 2
    state.policyCargoRiskSettings.initErr = error
    state.policyCargoRiskSettings.menu = {}
  },
  [POLICYCARGORISK_SAVE_LOADING](state) {
    state.policy.polCargoRisk.init = 0
    state.policy.polCargoRisk.saving = true
    state.policy.polCargoRisk.saveError.fieldMessages = []
    state.policy.polCargoRisk.saveError.messages = []
  },
  [POLICYCARGORISK_SAVE_SUCCESS](state) {
    state.policy.polCargoRisk.init = 1
    state.policy.polCargoRisk.saving = false
    state.policy.polCargoRisk.saveError.fieldMessages = []
    state.policy.polCargoRisk.saveError.messages = []
  },
  [POLICYCARGORISK_SAVE_FAIL](state, errMsgs) {
    state.policy.polCargoRisk.init = 2
    state.policy.polCargoRisk.saving = false
    state.policy.polCargoRisk.saveError.fieldMessages = errMsgs.fieldMessages
    state.policy.polCargoRisk.saveError.messages = errMsgs.messages
  },
  [POLRISKBLK_SAVE_LOADING](state) {
    state.policy.polRiskBlk.init = 0
    state.policy.polRiskBlk.saving = true
    state.policy.polRiskBlk.saveError.fieldMessages = []
    state.policy.polRiskBlk.saveError.messages = []
  },
  [POLRISKBLK_SAVE_SUCCESS](state) {
    state.policy.polRiskBlk.init = 1
    state.policy.polRiskBlk.saving = false
    state.policy.polRiskBlk.saveError.fieldMessages = []
    state.policy.polRiskBlk.saveError.messages = []
  },
  [POLRISKBLK_SAVE_FAIL](state, errMsgs) {
    state.policy.polRiskBlk.init = 2
    state.policy.polRiskBlk.saving = false
    state.policy.polRiskBlk.saveError.fieldMessages = errMsgs.fieldMessages
    state.policy.polRiskBlk.saveError.messages = errMsgs.messages
  },
  [RISKTRAILER_SAVE_LOADING](state) {
    state.policy.riskTrailer.init = 0
    state.policy.riskTrailer.saving = true
    state.policy.riskTrailer.saveError.fieldMessages = []
    state.policy.riskTrailer.saveError.messages = []
  },
  [RISKTRAILER_SAVE_SUCCESS](state) {
    state.policy.riskTrailer.init = 1
    state.policy.riskTrailer.saving = false
    state.policy.riskTrailer.saveError.fieldMessages = []
    state.policy.riskTrailer.saveError.messages = []
  },
  [RISKTRAILER_SAVE_FAIL](state, errMsgs) {
    state.policy.riskTrailer.init = 2
    state.policy.riskTrailer.saving = false
    state.policy.riskTrailer.saveError.fieldMessages = errMsgs.fieldMessages
    state.policy.riskTrailer.saveError.messages = errMsgs.messages
  },
  [POLBORDITEM_SAVE_LOADING](state) {
    state.policy.polBordItem.init = 0
    state.policy.polBordItem.saving = true
    state.policy.polBordItem.saveError.fieldMessages = []
    state.policy.polBordItem.saveError.messages = []
  },
  [POLBORDITEM_SAVE_SUCCESS](state) {
    state.policy.polBordItem.init = 1
    state.policy.polBordItem.saving = false
    state.policy.polBordItem.saveError.fieldMessages = []
    state.policy.polBordItem.saveError.messages = []
  },
  [POLBORDITEM_SAVE_FAIL](state, errMsgs) {
    state.policy.polBordItem.init = 2
    state.policy.polBordItem.saving = false
    state.policy.polBordItem.saveError.fieldMessages = errMsgs.fieldMessages
    state.policy.polBordItem.saveError.messages = errMsgs.messages
  },
  [POLEMPYEEDET_SAVE_LOADING](state) {
    state.policy.polEmpyeeDet.init = 0
    state.policy.polEmpyeeDet.saving = true
    state.policy.polEmpyeeDet.saveError.fieldMessages = []
    state.policy.polEmpyeeDet.saveError.messages = []
  },
  [POLEMPYEEDET_SAVE_SUCCESS](state) {
    state.policy.polEmpyeeDet.init = 1
    state.policy.polEmpyeeDet.saving = false
    state.policy.polEmpyeeDet.saveError.fieldMessages = []
    state.policy.polEmpyeeDet.saveError.messages = []
  },
  [POLEMPYEEDET_SAVE_FAIL](state, errMsgs) {
    state.policy.polEmpyeeDet.init = 2
    state.policy.polEmpyeeDet.saving = false
    state.policy.polEmpyeeDet.saveError.fieldMessages = errMsgs.fieldMessages
    state.policy.polEmpyeeDet.saveError.messages = errMsgs.messages
  }
}
